import { TCoordinates } from '../map-manager'

export const useWebGeolocation = () => {
  const getUserLocation = (): Promise<TCoordinates> => {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        position => {
          resolve({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          })
        },
        reject,
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0,
        },
      )
    })
  }

  return {
    getWebUserLocation: getUserLocation,
  }
}
